(function () {
    if (window.google && window.google.maps && window.google.maps.places) {
      window.__gmapsReady = Promise.resolve();
      return;
    }
    if (window.__gmapsReady && typeof window.__gmapsReady.then === "function") return;

    window.__gmapsReady = new Promise(function (resolve) {
      document.addEventListener("gmaps:ready", resolve, { once: true });

      var t = setInterval(function () {
        if (window.google && window.google.maps && window.google.maps.places) {
          clearInterval(t);
          resolve();
        }
      }, 50);

      setTimeout(function () { clearInterval(t); }, 10000);
    });
  })();

(function(){
  "use strict";

  const $ = (s,ctx=document)=>ctx.querySelector(s);
  const $$ = (s,ctx=document)=>Array.from(ctx.querySelectorAll(s));

  const PRICE = window.AVAL?.pricing || window.AVAL_PRICE || null;

  function initReviewToggle(){
    const toggle = $(".ah-review-toggle");
    const inner = $("#ah-review-more-inner");
    if(!toggle || !inner) return;

    function setOpen(isOpen){
      toggle.setAttribute("aria-expanded",String(isOpen));
      inner.hidden = !isOpen;
      toggle.textContent = isOpen ? "Weitere Kundenstimmen ausblenden →" : "Weitere Kundenstimmen anzeigen →";
    }

    setOpen(false);
    toggle.addEventListener("click",()=>setOpen(toggle.getAttribute("aria-expanded") !== "true"));
  }

  function initCalculator(){
  const root = $("#aval-quick-price-hero");
  if(!root || root.dataset.ready === "true") return;
  root.dataset.ready = "true";

  const els = {
    form:$("#hqp-form",root),
    pickup:$("#hqp-pickup",root),
    dropoff:$("#hqp-dropoff",root),
    calc:$("#hqp-calc",root),
    cta:$("#hqp-cta",root),
    priceLine:$("#hqp-price-line",root),
    priceOut:$("#hqp-price",root),
    msg:$("#hqp-msg",root)
  };

  if(!PRICE){
    if(els.calc) els.calc.disabled = true;
    if(els.cta) els.cta.setAttribute('aria-disabled','true');
    if(els.msg) els.msg.textContent = 'Die Preiskalkulation konnte nicht geladen werden. Bitte laden Sie die Seite neu oder kontaktieren Sie uns direkt.';
    return;
  }

  const HH = PRICE.HH;
  const PRICE_LOGIC_VERSION = PRICE.PRICE_LOGIC_VERSION;
  const P_EXTRA_STOP = PRICE.P_EXTRA_STOP;
  const EXTRA_KM_BLOCK_KM = PRICE.EXTRA_KM_BLOCK_KM;
  const EXTRA_KM_BLOCK_PRICE = PRICE.EXTRA_KM_BLOCK_PRICE;
  const VIA_TOL = PRICE.VIA_TOL;

  let gm = { dm:null, geocoder:null };
  let pickPlace = null;
  let dropPlace = null;
  let lastPrice = null;
  let lastPriceComponents = null;
  let running = false;

  const geocodeCache = new Map();
  const distCache = new Map();

  function normAddr(s){ return (s || "").trim().replace(/\s+/g, " ").toLowerCase(); }
  function toRad(d){ return (d * Math.PI) / 180; }

  function haversineKm(a,b){
    const R = 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const s = Math.sin(dLat/2)**2 + Math.cos(toRad(a.lat))*Math.cos(toRad(b.lat))*Math.sin(dLng/2)**2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  function roundLL(ll){
    return {
      lat: Math.round(ll.lat * 10000) / 10000,
      lng: Math.round(ll.lng * 10000) / 10000
    };
  }

  function distKey(a,b){
    const A = roundLL(a);
    const B = roundLL(b);
    return `${A.lat},${A.lng}|${B.lat},${B.lng}`;
  }

  async function drivingKmLL(a,b){
    const key = distKey(a,b);
    if(distCache.has(key)) return distCache.get(key);

    let km;

    try{
      const resp = await new Promise((res,rej)=>{
        gm.dm.getDistanceMatrix(
          {
            origins:[{ location:new google.maps.LatLng(a.lat,a.lng) }],
            destinations:[{ location:new google.maps.LatLng(b.lat,b.lng) }],
            travelMode:"DRIVING",
            unitSystem:google.maps.UnitSystem.METRIC
          },
          (r,s)=>(s === "OK" ? res(r) : rej(s))
        );
      });

      const el = resp?.rows?.[0]?.elements?.[0];
      km = el && el.status === "OK" ? el.distance.value / 1000 : haversineKm(a,b) * 1.15;
    }catch(e){
      km = haversineKm(a,b) * 1.15;
    }

    distCache.set(key, km);
    return km;
  }

  function getFromComps(place,type){
    const comps = Array.isArray(place?.address_components) ? place.address_components : [];
    const c = comps.find(c => (c.types || []).includes(type));
    return (c && (c.long_name || c.short_name)) || "";
  }

  function hasComp(place,type){
    return !!getFromComps(place,type);
  }

  function formatFromComps(comps){
    const get = (type)=>{
      const c = (Array.isArray(comps) ? comps : []).find(x => (x.types || []).includes(type));
      return (c && (c.long_name || c.short_name)) || "";
    };

    const street = get("route");
    const streetNo = get("street_number");
    const postal = get("postal_code");

    const city =
      get("locality") ||
      get("postal_town") ||
      get("administrative_area_level_2") ||
      get("administrative_area_level_3");

    const hasStreet = !!street;
    const hasNo = !!streetNo;
    const hasPostal = !!postal;
    const hasCity = !!city;

    if(!hasStreet && !hasPostal && hasCity) return city;
    if(!hasStreet && hasPostal) return hasCity ? `${postal} ${city}` : postal;

    if(hasStreet && !hasNo){
      const tail = hasPostal && hasCity ? `${postal} ${city}` : (hasCity ? city : (hasPostal ? postal : ""));
      return tail ? `${street}, ${tail}` : street;
    }

    if(hasStreet && hasNo){
      const head = `${street} ${streetNo}`.trim();
      const tail = hasPostal && hasCity ? `${postal} ${city}` : (hasCity ? city : (hasPostal ? postal : ""));
      return tail ? `${head}, ${tail}` : head;
    }

    if(hasPostal && hasCity) return `${postal} ${city}`;
    if(hasCity) return city;
    if(hasPostal) return postal;

    return "";
  }

  function formatPlaceOrResult(obj,fallbackText){
    const comps = obj?.address_components || [];
    const formatted = formatFromComps(comps);
    if(formatted) return formatted;

    const fa = (obj?.formatted_address || "").trim();
    if(fa) return fa;

    return (fallbackText || "").trim();
  }

  function isHamburg(place,inputVal){
    const admin1 = getFromComps(place,"administrative_area_level_1");
    const locality = getFromComps(place,"locality") || getFromComps(place,"postal_town");

    if(/hamburg/i.test(admin1) || /hamburg/i.test(locality)) return true;

    const txt = (((place?.formatted_address) || "") + " " + (inputVal || "")).toLowerCase();
    return /\bhamburg\b/.test(txt.replace(/[,_/]/g," "));
  }

  function cityName(place){
    return getFromComps(place,"locality") ||
      getFromComps(place,"postal_town") ||
      getFromComps(place,"administrative_area_level_2") ||
      getFromComps(place,"administrative_area_level_3") ||
      "";
  }

  function isPreciseAddress(place){
    return !!(
      hasComp(place,"route") &&
      hasComp(place,"street_number") &&
      hasComp(place,"postal_code") &&
      cityName(place)
    );
  }

  function assertPreciseAddress(place,label){
    if(!place || !place.ll){
      throw `${label}: Adresse konnte nicht eindeutig erkannt werden. Bitte vollständige Adresse auswählen.`;
    }

    if(place.partial_match){
      throw `${label}: Adresse wurde nur teilweise gefunden. Bitte Straße, Hausnummer, PLZ und Ort prüfen.`;
    }

    if(!isPreciseAddress(place)){
      throw `${label}: Bitte vollständige Adresse inklusive Straße, Hausnummer, PLZ und Ort eingeben oder aus der Vorschlagsliste auswählen.`;
    }
  }

  function round2(value){
  return PRICE.round2(value);
}


function calculateBasePrice(params){
  return PRICE.calculateBasePrice(params);
}

  function fmt(value){
    return round2(value).toFixed(2).replace('.', ',');
  }

  function geocode(addr,place){
    const key = normAddr(addr);
    if(!place && geocodeCache.has(key)) return Promise.resolve(geocodeCache.get(key));

    return new Promise((res,rej)=>{
      if(place?.geometry?.location){
        const out = {
          formatted_address: place.formatted_address || "",
          address_components: place.address_components || [],
          partial_match: false,
          ll: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        };

        if(key) geocodeCache.set(key,out);
        return res(out);
      }

      if(!gm.geocoder){
        rej("Google Maps ist aktuell nicht verfügbar. Die Sofortkalkulation ist derzeit nicht möglich. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.");
        return;
      }

      gm.geocoder.geocode(
        { address:addr, componentRestrictions:{ country:"DE" } },
        (r,s)=>{
          if(s === "OK" && r[0]){
            const out = {
              formatted_address: r[0].formatted_address || "",
              address_components: r[0].address_components || [],
              partial_match: !!r[0].partial_match,
              types: r[0].types || [],
              ll: {
                lat: r[0].geometry.location.lat(),
                lng: r[0].geometry.location.lng()
              }
            };

            if(key) geocodeCache.set(key,out);
            res(out);
          }else{
            rej("Adresse konnte nicht gefunden werden. Bitte Hausnummer und PLZ ergänzen oder einen Vorschlag auswählen.");
          }
        }
      );
    });
  }

  function setBusy(on){
    els.calc.disabled = !!on;
    els.calc.textContent = on ? "Preis wird berechnet…" : "Jetzt Preis kalkulieren";
  }

  async function calcPrice(aText,bText){
    if(running) return;

    running = true;
    lastPrice = null;
    lastPriceComponents = null;
    els.msg.textContent = "";
    els.priceLine.classList.remove("is-visible");
    els.cta.disabled = true;
    setBusy(true);

    try{
      const [A,B] = await Promise.all([
        geocode(aText,pickPlace),
        geocode(bText,dropPlace)
      ]);

      assertPreciseAddress(A,"Abholadresse");
      assertPreciseAddress(B,"Zustelladresse");

      const A_fmt = formatPlaceOrResult(A,aText);
      const B_fmt = formatPlaceOrResult(B,bText);

      if(A_fmt) els.pickup.value = A_fmt;
      if(B_fmt) els.dropoff.value = B_fmt;

      const [dHH_A,dHH_B,dAB] = await Promise.all([
        drivingKmLL(HH,A.ll),
        drivingKmLL(HH,B.ll),
        drivingKmLL(A.ll,B.ll)
      ]);

      const A_inHH = isHamburg(A,aText);
      const B_inHH = isHamburg(B,bText);

      const cityA = cityName(A).toLowerCase();
      const cityB = cityName(B).toLowerCase();

      const basePricing = calculateBasePrice({
        AB: dAB,
        hA: dHH_A,
        hB: dHH_B,
        pickupInHamburg: A_inHH,
        deliveryInHamburg: B_inHH,
        cityA,
        cityB
      });

      const net = basePricing.basePrice;
      const routeType = basePricing.routeType;
      const pricingDistanceKm = basePricing.pricingDistanceKm;
      const sameCity = basePricing.sameCityOutsideHamburg;
      const viaFeasible = basePricing.hamburgOnRoute;
      const total = round2(net);

      lastPrice = total;
      lastPriceComponents = {
        pricing_version: PRICE_LOGIC_VERSION,
        route_type: routeType,
        base_route_km: round2(dAB),
        pricing_distance_km: round2(pricingDistanceKm),
        pickup_to_hamburg_km: round2(dHH_A),
        delivery_to_hamburg_km: round2(dHH_B),
        pickup_in_hamburg: A_inHH,
        delivery_in_hamburg: B_inHH,
        same_city_outside_hamburg: !!sameCity,
        via_feasible: !!viaFeasible,
        base_price: round2(net),
        extra_stop_count: 0,
        duplicate_stop_count: 0,
        priced_stop_count: 2,
        base_physical_stop_count: 2,
        full_route_km: round2(dAB),
        extra_km_total: 0,
        included_extra_km: 0,
        billable_extra_km: 0,
        extra_stop_base_price: 0,
        extra_stop_km_price: 0,
        extra_stop_total: 0,
        net_total: total
      };
      els.priceOut.textContent = fmt(total);
      els.priceLine.classList.add("is-visible");
      els.cta.disabled = false;
    }catch(e){
      els.msg.textContent = String(e || "Preisberechnung nicht möglich. Bitte prüfen Sie die Adressen.");
      lastPrice = null;
      lastPriceComponents = null;
    }finally{
      running = false;
      setBusy(false);
    }
  }

  function goToDetails(){
    const target = root.getAttribute("data-target-url") || "/pages/jetzt-preis-fur-kurierfahrt-kalkulieren";

    const params = new URLSearchParams({
      abholadresse:(els.pickup.value || "").trim(),
      zieladresse:(els.dropoff.value || "").trim(),
      preis:lastPrice != null ? lastPrice.toFixed(2) : "",
      pricing_version:lastPriceComponents?.pricing_version || PRICE_LOGIC_VERSION,
      route_type:lastPriceComponents?.route_type || ""
    });

    window.location.href = target + "?" + params.toString();
  }

  function initGoogle(){
    if(root.__avalHeroGoogleInit) return;
    root.__avalHeroGoogleInit = true;

    gm.dm = new google.maps.DistanceMatrixService();
    gm.geocoder = new google.maps.Geocoder();

    const opts = {
      componentRestrictions:{ country:["de"] },
      fields:["place_id","geometry","formatted_address","address_components"]
    };

    const acPick = new google.maps.places.Autocomplete(els.pickup,opts);
    const acDrop = new google.maps.places.Autocomplete(els.dropoff,opts);

    acPick.addListener("place_changed",()=>{
      pickPlace = acPick.getPlace() || null;
      const fmt = formatPlaceOrResult(pickPlace,els.pickup.value);
      if(fmt) els.pickup.value = fmt;
      lastPrice = null;
      lastPriceComponents = null;
      els.priceLine.classList.remove("is-visible");
      els.cta.disabled = true;
    });

    acDrop.addListener("place_changed",()=>{
      dropPlace = acDrop.getPlace() || null;
      const fmt = formatPlaceOrResult(dropPlace,els.dropoff.value);
      if(fmt) els.dropoff.value = fmt;
      lastPrice = null;
      lastPriceComponents = null;
      els.priceLine.classList.remove("is-visible");
      els.cta.disabled = true;
    });

    els.pickup.addEventListener("input",()=>{
      pickPlace = null;
      lastPrice = null;
      lastPriceComponents = null;
      els.priceLine.classList.remove("is-visible");
      els.cta.disabled = true;
    });

    els.dropoff.addEventListener("input",()=>{
      dropPlace = null;
      lastPrice = null;
      lastPriceComponents = null;
      els.priceLine.classList.remove("is-visible");
      els.cta.disabled = true;
    });
  }

  els.form.addEventListener("submit",async (e)=>{
    e.preventDefault();

    const a = (els.pickup.value || "").trim();
    const b = (els.dropoff.value || "").trim();

    if(!a || !b){
      els.msg.textContent = "Bitte Abhol- und Zustelladresse eingeben.";
      return;
    }

    try{
      if(window.AVAL && typeof window.AVAL.loadMaps === "function"){
        const ready = await window.AVAL.loadMaps();
        if(ready && !root.__avalHeroGoogleInit) initGoogle();
      }
    }catch(error){}

    if(!gm.dm || !gm.geocoder){
      els.msg.textContent = "Die Kartenfunktion ist aktuell nicht verfügbar. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.";
      return;
    }

    calcPrice(a,b);
  });

  els.cta.addEventListener("click",()=>{
    if(!els.cta.disabled) goToDetails();
  });

  if(window.__gmapsReady?.then){
    window.__gmapsReady.then(initGoogle).catch(()=>{
      els.msg.textContent = "Google Maps ist aktuell nicht verfügbar.";
    });
  }else if(window.google?.maps?.places){
    initGoogle();
  }else{
    els.msg.textContent = "Google Maps ist aktuell nicht verfügbar.";
  }
}

  function initSlider(){
    const view = $("#avalViewport");
    const track = $("#avalTrack");
    if(!view || !track || view.dataset.ready === "true") return;
    view.dataset.ready = "true";

    let started = false;

    function startSlider(){
      if(started) return;
      started = true;

      const originals = Array.from(track.children);
      const block = originals.length;
      if(!block) return;

      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function makeClone(node){
        const clone = node.cloneNode(true);
        clone.setAttribute("aria-hidden","true");
        clone.querySelectorAll("img").forEach(img=>{img.alt = "";});
        return clone;
      }

      originals.map(makeClone).reverse().forEach(node=>track.insertBefore(node,track.firstChild));
      originals.map(makeClone).forEach(node=>track.appendChild(node));

      let idx = block;
      let slideW = 0;
      let currentX = 0;
      let rafId = 0;
      let autoTimer = 0;
      let playing = !prefersReducedMotion;
      let dragging = false;
      let pointerStartX = 0;
      let dragStartX = 0;
      let velocityX = 0;
      let lastX = 0;
      let lastT = 0;

      const duration = 420;
      const delay = 2800;

      function ease(t){return 1 - (1 - t) * (1 - t);}
      function stepWidth(){
        const slide = $(".aval-slide",track);
        if(!slide) return 0;
        const rect = slide.getBoundingClientRect();
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        return rect.width + gap;
      }

      function setX(x){
        currentX = x;
        track.style.transform = `translate3d(${x}px,0,0)`;
      }

      function jumpTo(i){
        track.style.transition = "none";
        setX(-(i * slideW));
        track.offsetHeight;
        track.style.transition = "";
      }

      function normalize(){
        if(idx >= block * 2){idx -= block;jumpTo(idx);}
        else if(idx < block){idx += block;jumpTo(idx);}
      }

      function clearAuto(){
        clearTimeout(autoTimer);
        cancelAnimationFrame(rafId);
      }

      function schedule(){
        if(!playing || prefersReducedMotion) return;
        clearTimeout(autoTimer);
        autoTimer = setTimeout(()=>animateTo(idx + 1),delay);
      }

      function pause(){playing = false;clearAuto();}
      function play(){if(prefersReducedMotion) return;if(!playing){playing = true;schedule();}}

      function animateTo(targetIdx){
        clearAuto();

        const startTime = performance.now();
        const from = -(idx * slideW);
        const to = -(targetIdx * slideW);
        const dist = to - from;

        function frame(now){
          const t = Math.min(1,(now - startTime) / duration);
          setX(from + dist * ease(t));

          if(t < 1) rafId = requestAnimationFrame(frame);
          else{
            idx = targetIdx;
            normalize();
            schedule();
          }
        }

        rafId = requestAnimationFrame(frame);
      }

      function endDrag(clientX){
        const dx = clientX - pointerStartX;
        const strong = Math.abs(dx) > slideW * .2 || Math.abs(velocityX) > .6;
        animateTo(idx + (strong ? (dx < 0 ? 1 : -1) : 0));
      }

      slideW = stepWidth();
      jumpTo(idx);
      schedule();

      view.addEventListener("pointerdown",e=>{
        dragging = true;
        pause();
        pointerStartX = e.clientX;
        dragStartX = currentX;
        lastX = e.clientX;
        lastT = performance.now();
        view.setPointerCapture && view.setPointerCapture(e.pointerId);
      },{passive:true});

      view.addEventListener("pointermove",e=>{
        if(!dragging) return;
        const dx = e.clientX - pointerStartX;
        setX(dragStartX + dx);
        const now = performance.now();
        velocityX = (e.clientX - lastX) / Math.max(1,now - lastT);
        lastX = e.clientX;
        lastT = now;
      },{passive:true});

      view.addEventListener("pointerup",e=>{
        if(!dragging) return;
        dragging = false;
        view.releasePointerCapture && view.releasePointerCapture(e.pointerId);
        endDrag(e.clientX);
      },{passive:true});

      view.addEventListener("pointercancel",e=>{
        if(!dragging) return;
        dragging = false;
        view.releasePointerCapture && view.releasePointerCapture(e.pointerId);
        endDrag(e.clientX);
      },{passive:true});

      view.addEventListener("mouseenter",pause,{passive:true});
      view.addEventListener("mouseleave",play,{passive:true});
      view.addEventListener("focusin",pause,{passive:true});
      view.addEventListener("focusout",play,{passive:true});

      view.addEventListener("keydown",e=>{
        if(e.key === "ArrowRight"){e.preventDefault();pause();animateTo(idx + 1);}
        if(e.key === "ArrowLeft"){e.preventDefault();pause();animateTo(idx - 1);}
        if(e.key === " " || e.key === "Spacebar"){e.preventDefault();playing ? pause() : play();}
      });

      window.addEventListener("resize",()=>{
        slideW = stepWidth();
        jumpTo(idx);
      },{passive:true});

      const visibilityObserver = new IntersectionObserver(entries=>{
        entries.forEach(entry=>entry.isIntersecting ? play() : pause());
      },{threshold:.3});

      visibilityObserver.observe(view);
    }

    const starterObserver = new IntersectionObserver((entries,observer)=>{
      if(entries[0] && entries[0].isIntersecting){
        startSlider();
        observer.disconnect();
      }
    },{threshold:.15});

    starterObserver.observe(view);
  }

  document.addEventListener("DOMContentLoaded",()=>{
    initReviewToggle();
    initCalculator();
    initSlider();
  });
})();
